<app-navbar title="Terminy dodatków i potrąceń"> </app-navbar>
<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>
<div class="card-body">
	<div class="form-inline">
		<label class="me-4"> Suma wartości rozliczonyych:{{ this.sumIsSettled.toFixed(2) }}</label>
		<label class="me-4"> Suma wartości nierozliczonych:{{ this.sumIsNotSettled.toFixed(2) }} </label>
		<label class="me-4"> Suma wartości: {{ this.sum.toFixed(2) }} </label>
	</div>
</div>

<app-settlement-term-filters
	userFilters="settlementBonusTerm"
	(selected)="filtersSelected($event)"
	[drivers]="parameters.drivers"
	[users]="parameters.users"
	[isSettled]="parameters.isSettled"
	[settlementBonusNameIds]="parameters.settlementBonusNameIds"
>
</app-settlement-term-filters>

<ng-container *ngIf="showTable">
	<mat-table
		[dataSource]="matData"
		matSort
		matSortActive="id"
		matSortDirection="asc"
		grouping="false"
		cdkDropList
		cdkDropListDisabled="true"
	>
		<ng-container matColumnDef="driver">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Kierowca </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.driver }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Typ </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="month">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Termin </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.month }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="value">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Wartość </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.value }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="comment">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Komentarz </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.comment }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="isSettled">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Rozliczono </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.isSettled }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="settlementsBonusId">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<a routerLink="/settlements/settlementBonus/{{ element.settlementsBonusId }}" target="_blank">
					<button mat-raised-button color="primary">Edytuj</button>
				</a>
			</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>

	<mat-paginator
		class="fixed-bottom"
		style="z-index: 0"
		[pageSizeOptions]="[20, 30, 50]"
		showFirstLastButtons
		aria-label="Select page of periodic elements"
	>
	</mat-paginator>
</ng-container>
